const state = {
  enable: true
}

export default function exceptionReporter(error, ...details) {
  if (state.enable) {
    window.console && window.console.error && window.console.error(error, ...details)
    if (window.Sentry && window.Sentry.withScope) {
      window.Sentry.withScope(function (scope) {
        scope.setExtra('details', details)
        window.Sentry.captureException(error)
      })
    } else if (window.ErrorLogger) {
      window.ErrorLogger.send(error)
    }
  }
}

exceptionReporter.sendTaggedMessage = function (tag, message, ...details) {
  if (state.enable) {
    window.console && window.console.info && window.console.info(message, ...details)
    if (window.Sentry && window.Sentry.withScope) {
      window.Sentry.withScope(function (scope) {
        scope.setLevel('info')
        scope.setExtra('details', details)
        if (tag) scope.setTag('subsystem', tag)
        window.Sentry.captureMessage(message)
      })
    } else if (window.ErrorLogger) {
      window.ErrorLogger.send(message)
    }
  }
}

export function enableExceptionReporter(enabled = true) {
  state.enable = enabled
}
